import { SpriteProperties } from "@lib/titan2/dist/game/control/properties/SpriteProperties";
import { TextFieldProperties } from "@lib/titan2/dist/game/control/properties/TextFieldProperties";
import { AbstractViewProperties } from "@lib/titan2/dist/game/view/properties/AbstractViewProperties";
import { Modules } from "@lib/titan2/dist/game/Constants";
import { Point } from "pixi.js";
import { ControlConstants } from "@lib/titan2/dist/game/control/constant/ControlConstants";
import { GameFontStyle } from "../style/GameFontStyle";
import { GameLang } from "../lang/GameLang";
import { FeatureType } from "../../../model/GameModel";
export class FeatureIntroProperties extends AbstractViewProperties {
    constructor() {
        super();
        this.setDefaultValues();
    }
    setDefaultValues() {
        this.icons = {
            5: new SpriteProperties("5_slingos_icon", "Game"),
            6: new SpriteProperties("6_slingos_icon", "Game"),
            7: new SpriteProperties("7_slingos_icon", "Game"),
            8: new SpriteProperties("8_slingos_icon", "Game"),
            9: new SpriteProperties("9_slingos_icon", "Game"),
            10: new SpriteProperties("10_slingos_icon", "Game"),
            12: {
                [FeatureType.GOLD_FISH]: new SpriteProperties("12_slingos_icon_catsUp", "Game"),
                [FeatureType.FISH_FOOD]: new SpriteProperties("12_slingos_icon_bagsUp", "Game"),
            }
        };
        const props = [...Object.values(this.icons), ...Object.values(this.icons[12])]
            .filter(icon => icon instanceof SpriteProperties);
        props.forEach(icon => {
            icon.scale.set(0.75, 0.75);
            icon.anchor = new Point(0.5, 0.5);
            icon.position.set(973, 270);
        });
        this.background = new SpriteProperties("BonusScreenIntroBg", Modules.GAME, new Point(973, 753), new Point(1.8, 0.6), new Point(0.5, 0.5));
        this.titleText = new TextFieldProperties(GameFontStyle.FEATURE_INFO_TITLE, new Point(973, 350), null, ControlConstants.CENTER, ControlConstants.CENTER, new Point(1560, 150));
        this.helpText = new TextFieldProperties(GameFontStyle.FEATURE_INFO_HELP_TEXT, new Point(973, 540), null, ControlConstants.CENTER, ControlConstants.CENTER, new Point(1560, 350));
        this.clickToSkipText = new TextFieldProperties(GameFontStyle.FEATURE_INFO_TAP_TO_SKIP, new Point(973, 880), GameLang.PRE_BONUS_PROMPT, ControlConstants.CENTER, ControlConstants.CENTER, new Point(700, 100));
        this.titleText.setMultiline(true);
        this.helpText.setMultiline(true);
    }
}
//# sourceMappingURL=FeatureIntroProperties.js.map